export { ProductListSectionThreeDS } from './product-list-section-three-ds'
// Single source of truth for the legacy + DS shared prop shape lives in the molecule directory.
export type { ProductListSectionThreeProps } from '@src/quince-components/src/molecules/productListSectionThree/product-list-section-three.types'
